module.exports = __webpack_public_path__ + "assets/img/icon-switching-theme.687d4987.png";